import { render } from "./RegisterTypeTable.vue?vue&type=template&id=0a064dcf"
import script from "./RegisterTypeTable.vue?vue&type=script&lang=js"
export * from "./RegisterTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__